var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAlertZj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 122,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-alert-zj_svg__clip0_1_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.918 44.44l-3.17 10.293-35.353 35.1H39.6L3.96 54.447 1.082 44.44l14.402-14.298c.647-.716 1.585-1.074 2.519-1.074h72c.938 0 1.872.358 2.519 1.074l14.397 14.298z",
    fill: "#FF662A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.002 0h-72c-2.015 0-3.6 1.574-3.6 3.575v93.407c0 2 1.585 3.574 3.6 3.574h72c2.015 0 3.6-1.573 3.6-3.574V3.575c0-2.001-1.585-3.575-3.6-3.575z",
    fill: "#D7D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.057 44.416A3.551 3.551 0 000 46.94v64.335c0 2.785 1.057 5.356 3.158 7.588l10.51-3.286L42.19 87.262 39.6 82.683 1.057 44.416zM108 111.276V46.941a3.55 3.55 0 00-1.057-2.525L68.399 82.683l-3.092 4.079 29.024 28.816 10.511 3.286c.024-.024.057-.032.086-.057 2.011-2.11 3.072-4.713 3.072-7.531z",
    fill: "#FF8758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.834 118.856c-2.233 2.074-4.826 3.144-7.631 3.144H10.8c-2.81 0-5.472-1.074-7.561-3.075-.074 0-.074 0-.074-.073L39.6 82.679h28.8l36.434 36.177z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.625 34.228h-7.168V27.11a2.38 2.38 0 00-2.39-2.372 2.38 2.38 0 00-2.389 2.372V36.6a2.38 2.38 0 002.39 2.372h9.557c1.322 0 2.39-1.06 2.39-2.372a2.379 2.379 0 00-2.39-2.372zm-9.557 21.35c-10.54 0-19.115-8.514-19.115-18.978 0-10.464 8.575-18.978 19.115-18.978S73.183 26.136 73.183 36.6c0 10.464-8.576 18.978-19.115 18.978zm0-42.7c-13.175 0-23.894 10.642-23.894 23.722 0 13.08 10.719 23.722 23.894 23.722 13.175 0 23.893-10.642 23.893-23.722 0-13.08-10.718-23.722-23.893-23.722z",
    fill: "#585992"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-alert-zj_svg__clip0_1_1440"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h108v122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/edit-alert-zj.d1ee51a9.svg";
export { SvgEditAlertZj as ReactComponent };